var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333008C3.31767 0.333008 0.333008 3.31767 0.333008 6.99967C0.333008 10.6817 3.31767 13.6663 6.99967 13.6663C10.6817 13.6663 13.6663 10.6817 13.6663 6.99967C13.6663 3.31767 10.6817 0.333008 6.99967 0.333008ZM8.99967 7.66634H4.99967C4.63167 7.66634 4.33301 7.36767 4.33301 6.99967C4.33301 6.63167 4.63167 6.33301 4.99967 6.33301H8.99967C9.36767 6.33301 9.66634 6.63167 9.66634 6.99967C9.66634 7.36767 9.36767 7.66634 8.99967 7.66634Z",
    fill: "#B00020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLabel);
export default __webpack_public_path__ + "static/media/delete-label.300ad5fee7f3e059a35906db2981d515.svg";
export { ForwardRef as ReactComponent };